import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormExtendedWithoutMarketingValidationSchema = Yup.object().shape({
    name: Yup.string().required(validationMessages.required),
    email: Yup.string().email().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    })
});
import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const registerFormExtendedWithoutMarketingValidationSchema = Yup.object().shape({
    name: Yup.string().required(validationMessages.required),
    email: Yup.string().email().required(validationMessages.required),
    phone: Yup.object({
        code: Yup.number().required(validationMessages.required),
        number: Yup.string().required(validationMessages.required)
    })
});
